import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FocusDirective } from './focus/focus.directive';
import { ModifyDirective } from './observers/modify.directive';
import { ObserveDirective } from './observers/observe.directive';
import { ResizeDirective } from './observers/resize.directive';
import { ResponsiveDirective } from './responsive/responsive.directive';
import { UniformDirective } from './uniform/uniform.directive';

@NgModule({
  declarations: [
    ResponsiveDirective,
    FocusDirective,
    ModifyDirective,
    ResizeDirective,
    ObserveDirective,
    UniformDirective,
  ],

  imports: [
    CommonModule
  ],

  exports: [
    ResponsiveDirective,
    FocusDirective,
    ModifyDirective,
    ResizeDirective,
    ObserveDirective,
    UniformDirective
  ]
})
export class DirectivesModule { }
